"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapText = mapText;
exports.mapRichText = mapRichText;
const jsx_runtime_1 = require("react/jsx-runtime");
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
const react_1 = __importDefault(require("react"));
const mapTable_1 = __importDefault(require("./mapTable"));
const IS_BOLD = 1 << 0;
const IS_ITALIC = 1 << 1;
const IS_STRIKETHROUGH = 1 << 2;
const IS_UNDERLINE = 1 << 3;
const IS_SUBSCRIPT = 1 << 5;
const IS_SUPERSCRIPT = 1 << 6;
const FORMAT_TAGS = {
    [IS_BOLD]: 'strong',
    [IS_ITALIC]: 'em',
    [IS_STRIKETHROUGH]: 's',
    [IS_UNDERLINE]: 'u',
    [IS_SUBSCRIPT]: 'sub',
    [IS_SUPERSCRIPT]: 'sup',
};
function mapText(text, mappers, spanish, packages, key, forms) {
    if (text?.text) {
        return applyFormatting({ node: text });
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: text.children?.map((node, i) => {
            if (node?.type === 'inlineBlock' && node.fields) {
                return mappers.mapBlock({
                    block: node.fields,
                    mappers,
                    spanish,
                    packages,
                    forms,
                });
            }
            if (node?.type === 'link' && node?.fields) {
                const url = 'url' in node.fields ? node.fields.url : '';
                return ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Link, { to: url, children: node.children?.map((child, j) => applyFormatting({
                        node: child,
                        key: `link-${key}-${j}-${url}`,
                    })) }, `link-${i}`));
            }
            return applyFormatting({ node, key: `text-${key}-${i}` });
        }) }));
}
function applyFormatting({ node, key, }) {
    let formattedText = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: node.text });
    Object.entries(FORMAT_TAGS).forEach(([bitmask, tag]) => {
        if (typeof node.format === 'number' && node.format & Number(bitmask)) {
            formattedText = react_1.default.createElement(tag, { key: `${key}-${bitmask}` }, formattedText);
        }
    });
    return (0, jsx_runtime_1.jsx)("span", { children: formattedText }, `span-${key}`);
}
function mapRichText({ richText, mappers, pageData, inHero, packages, forms, listIcon, blockKey, sectionKey, }) {
    const spanish = pageData?.spanish ?? false;
    const children = richText?.root?.children || [];
    const elements = [];
    const key = `${sectionKey}-${blockKey}`;
    for (let i = 0; i < children.length; i++) {
        const node = children[i];
        if (node.type === 'heading') {
            elements.push((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Typography, { variant: node.tag || 'body', children: mapText(node, mappers, spanish, packages, key, forms) }, `heading-${key}-${i}}`));
        }
        else if (node.type === 'list') {
            const listType = node.tag === 'ol' ? 'ordered' : 'unordered';
            elements.push((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.List, { type: listType, children: node?.children?.map((item, j) => {
                    const nestedItems = item?.children?.[0]?.children || [];
                    if (nestedItems?.length > 0) {
                        // Sometimes the list items are wrapped in paragraphs so we need to support this for now
                        return ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.ListItem, { listIcon: listIcon, children: nestedItems.map((itm) => mapText(itm, mappers, spanish, packages, key, forms)) }, `nested-item-${key}-${j}`));
                    }
                    return ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.ListItem, { listIcon: listIcon, children: mapText(item, mappers, spanish, packages, key, forms) }, `item-${key}-${i}-${j}}`));
                }) }, `list-${key}-${i}`));
        }
        else if (node?.type === 'link' && node?.fields) {
            const url = 'url' in node.fields ? node.fields.url : '';
            return ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Link, { to: url, children: node.children?.map((child, j) => applyFormatting({
                    node: child,
                    key: `link-${key}-${i}-${j}`,
                })) }, `link-${key}-${i}`));
        }
        else if (node?.type === 'block' && node.fields) {
            const element = mappers.mapBlock({
                block: node.fields,
                mappers,
                spanish,
                inHero,
                packages,
                forms,
                sectionKey,
            });
            if (element) {
                elements.push(element);
            }
        }
        else if (node?.type === 'table') {
            const table = (0, mapTable_1.default)({ data: node, mappers, packages, key });
            elements.push(table);
        }
        else {
            elements.push((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Typography, { variant: node.tag || 'body', children: mapText(node, mappers, spanish, packages, key, forms) }, `typography-${blockKey}`));
        }
    }
    return elements;
}
